// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"68":"97b0f13b","366":"b9466c13","2042":"9bcd5bbb","7073":"34cb3524","7557":"68a92f54","8703":"a411638d"}[chunkId] + ".chunk.css";
};